<template>
  <el-form ref="form" :model="formData">
    <h3 class="blue-text">{{title}}</h3>
    <div class="row">
      <div class="col-xl-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('po')"
          prop="po"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <el-input
            :value="formData.po"
            @input="$emit('onUpdatePO', valueTrimLeft($event))"
          />
        </el-form-item>
      </div>
      <div class="col-xl-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('po-date')"
          :rules="getValidationRule('required')"
          prop="poDate"
          class="material-style"
        >
          <date-picker
            v-model="form.poDate"
            @change="autoSave('poDate', { required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-xl-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('requested-date')"
          prop="requestedDate"
          class="material-style"
        >
          <date-picker
            v-model="form.requestedDate"
            @change="autoSave('requestedDate')"
          />
        </el-form-item>
      </div>
      <div class="col-xl-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('order-rating-score')"
          prop="scoreID"
          class="material-style"
        >
          <select-response
            :model.sync="form.orderRatingScoreID"
            @on-change="autoSave('orderRatingScoreID')"
            :fields="{ id: 'id', title: 'scoreText' }"
            :data="dataSourceScore.records"
            :isLoading="dataSourceScore.loading"
          />
        </el-form-item>
      </div>
      <div class="col-xl-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('payment-term')"
          prop="paymentTermID"
          class="material-style">
          <select-response
            :model.sync="form.paymentTermID"
            @on-change="autoSave('paymentTermID')"
            :isLoading="dataSourcePaymentTerm.loading"
            :data="dataSourcePaymentTerm.records"
          />
        </el-form-item>
      </div>
      <div class="col-xl-4 col-md-12 col-12">
        <el-form-item
          :label="L10n('customer-forwarder')"
          prop="customerForwarderID"
          class="material-style"
        >
          <select-forwarder
            :companyID="data.customerCompanyID"
            :model.sync="form.customerForwarderID"
            @on-change="autoSave('customerForwarderID')"
          />
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('ship')"
          prop="shipToCompanyID"
          class="material-style"
        >
          <select-company
            :model.sync="form.shipToCompanyID"
            @on-change="(id) => mixChangeShipToID(id)"
            @on-created="mixCreateShipTo"
          >
          </select-company>
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('ship-detail')"
          prop="shipToCompanyDetailID"
          class="material-style">
          <select-company-detail
            :model.sync="form.shipToCompanyDetailID"
            :companyID="form.shipToCompanyID"
            @on-change="autoSave('shipToCompanyDetailID')"
          />
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('ship-contact')"
          prop="shipToCompanyContactID"
          class="material-style">
          <select-company-contact
            :model.sync="form.shipToContactID"
            :companyID="form.shipToCompanyID"
            @on-change="autoSave('shipToContactID')"
          />
        </el-form-item>
      </div>

    </div>
    <button-line @click="handlerNextStep">
      {{L10n('create-po')}}
    </button-line>
  </el-form>
</template>

<script>
import { mixUpdateShipTo } from '@/mixins/companies'
import { waitValue } from '@/utils/promises'
import Form from '@/components/Form/Form'

export default {
  name: 'RFQPoForm',
  mixins: [Form, mixUpdateShipTo],
  components: {
    'select-forwarder': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectForwarder/Index.vue'),
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue'),
    'select-company-contact': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyContact/Index.vue'),
    'select-company-detail': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyDetail/Index.vue'),
    'button-line': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/ButtonLine.vue')
  },
  props: {
    fieldPO: { required: true },
    title: { type: String },
    isValid: { type: Boolean }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler () {
        waitValue(() => (this.$refs['form']))
          .then((form) => {
            form.validate((isValid) => {
              this.$emit('update:isValid', isValid)
              form.clearValidate()
            })
          })
      }
    }
  },
  computed: {
    dataSourceScore () {
      return this.API('Scores/GetAllDynamic?select=id,scoreText')
    },
    dataSourcePaymentTerm () {
      return this.API('PaymentTerms/GetAllDynamic?select=id,title&orderBy=title')
    },
    formData () {
      return {
        ...this.form,
        po: this.fieldPO
      }
    }
  },
  methods: {
    handlerNextStep () {
      this.$refs.form.validate()
        .then(() => {
          this.$emit('onCreatePO', { id: this.data.id, ...this.formData })
        })
    }
  }
}
</script>
